export const STATUS_TEXTS = {
  // Texts for apprentices application statuses starts here
  apprentice: {
    draft: {
      process: 'Lärling påbörjar anmälan',
      applicationStep: 'Utkast',
      motive: 'Lärlingen har skapat ett utkast men anmälan har inte skickats in och är antagligen inte komplett.',
      next: 'Lärlingen behöver bekräfta och skicka in anmälan.',
      dependsOn: 'Lärlingen',
      actor: 'Lärlingen'
    },
    confirmedByStudent: {
      process: 'Lärling påbörjar anmälan',
      applicationStep: 'Bekräftad av lärling',
      motive: 'Lärlingen har bekräftat och skickat in anmälan till företaget.',
      next: 'Företaget behöver bekräfta och godkänna anmälan.',
      dependsOn: 'Företaget',
      actor: 'Lärlingen'
    },
    confirmedAndApprovedByCompany: {
      process: 'Lärling påbörjar anmälan',
      applicationStep: 'Bekräftad och godkänd av företag',
      motive: 'Företaget har bekräftat anmälan som lärlingen skapat och godkänt den.',
      next: 'BYN behöver godkänna anmälan.',
      dependsOn: 'Regionär med behörighet till BYN {{region}}',
      actor: 'Företaget'
    },
    ordered: {
      process: 'Gemensamma steg lärlingsanmälan: Företagslärling',
      applicationStep: 'Bekräftad anmälan',
      motive: 'En BYN-regionär har granskat och bekräftar anmälan och lärlingens kompletteringsbehov.',
      next: 'En annan BYN-regionär behöver godkänna beställningsunderlaget',
      dependsOn: 'Annan regionär än {{orderedBy}} med behörighet till BYN {{region}}',
      actor: '{{orderedBy}} (BYN {{region}})'
    },
    approved: {
      process: 'Gemensamma steg lärlingsanmälan: Företagslärling',
      applicationStep: 'Godkänd anmälan',
      motive: 'En annan BYN-regionär har godkänt anmälan och beställningsunderlaget är skickat till företaget.',
      next: 'Företaget behöver acceptera betalningsansvar för beställningsunderlaget.',
      dependsOn: 'Företaget',
      actor: '{{approvedBy}} (BYN {{region}})'
    },
    closed: {
      process: 'Gemensamma steg lärlingsanmälan: Företagslärling',
      applicationStep: 'Klar',
      motive: 'Företaget godkänner beställningsunderlaget och accepterar betalningsansvar. Härmed är lärlingsanmälan klar.',
      next: 'En beställning för distansutbildning skapas i Registret, företaget faktureras och beställningen skickas till distansutbildningsleverantören.',
      dependsOn: 'BYN kansli',
      actor: 'Företaget'
    },
    basicEducationCertificateIssued: {
      process: 'Gemensamma steg lärlingsanmälan: Kvalificeringstid',
      applicationStep: 'Granskad och godkänd grundutbildning',
      motive: 'En BYN-regionär har granskat och bedömt grundutbildningen som godkänd baserat på anmälan.',
      next: 'En annan BYN-regionär behöver bekräfta godkännandet av grundutbildningen.',
      dependsOn: 'Annan regionär än {{orderedBy}} med behörighet till BYN {{region}}',
      actor: '{{orderedBy}} (BYN {{region}})'
    },
    basicEducationCertificateApproved: {
      process: 'Gemensamma steg lärlingsanmälan: Kvalificeringstid',
      applicationStep: 'Klar',
      motive: 'En annan BYN-regionär har bekräftat godkännandet av grundutbildningen. Härmed är lärlingsanmälan klar.',
      next: 'Kvalificeringstiden har startat för lärlingen.',
      dependsOn: 'Lärlingen',
      actor: '{{approvedBy}} (BYN {{region}})'
    },
    closedDistanceEducation: {
      process: 'Gemensamma steg lärlingsanmälan: Kvalificeringstid',
      applicationStep: 'Klar',
      motive: 'En annan BYN-regionär har bekräftat godkännandet av grundutbildningen. Härmed är lärlingsanmälan klar.',
      next: 'Kvalificeringstiden har startat för lärlingen.',
      dependsOn: 'Lärlingen',
      actor: '{{approvedBy}} (BYN {{region}})'
    },
    transferDistanceEducationIssued: {
      process: 'Gemensamma steg lärlingsanmälan: Företagslärling',
      applicationStep: 'Bekräftad anmälan',
      motive: 'En BYN-regionär har granskat och bekräftat förflyttning.',
      next: 'En annan BYN-regionär behöver godkänna förflyttningen.',
      dependsOn: 'Annan regionär än {{orderedBy}} med behörighet till BYN {{region}}',
      actor: '{{orderedBy}} (BYN {{region}})'
    },
    transferDistanceEducationApproved: {
      process: 'Flytt av lärling till nytt företag',
      applicationStep: 'Klar',
      motive: 'Förflyttning till nytt företag har genomförts.',
      next: 'Lärlingen fortsätter med grundutbildningen på det nya företaget.',
      dependsOn: 'Lärlingen',
      actor: '{{approvedBy}} (BYN {{region}})'
    },
    transferBasicEducationCertificateIssued: {
      process: 'Gemensamma steg lärlingsanmälan: Kvalificeringstid',
      applicationStep: 'Bekräftad anmälan',
      motive: 'En BYN-regionär har granskat och bekräftat förflyttning.',
      next: 'En annan BYN-regionär behöver godkänna förflyttningen.',
      dependsOn: 'Annan regionär än {{orderedBy}} med behörighet till BYN {{region}}',
      actor: '{{orderedBy}} (BYN {{region}})'
    },
    transferBasicEducationCertificateApproved: {
      process: 'Gemensamma steg lärlingsanmälan: Kvalificeringstid',
      applicationStep: 'Klar',
      motive: 'Förflyttning till nytt företag har genomförts.',
      next: 'Lärlingen fortsätter med kvalificeringstiden på det nya företaget.',
      dependsOn: 'Lärlingen',
      actor: '{{approvedBy}} (BYN {{region}})'
    },
  },
  // Texts for apprentices application statuses end here
  // Texts for company application statuses START here
  company: {
    draft: {
      process: 'Företaget påbörjar anmälan',
      applicationStep: 'Utkast',
      motive: 'Företaget har skapat ett utkast men anmälan har inte skickats till lärlingen och är antagligen inte komplett.',
      next: 'Företaget behöver bekräfta och skicka in anmälan.',
      dependsOn: 'Företaget',
      actor: 'Företaget'
    },
    confirmedByCompany: {
      process: 'Företaget påbörjar anmälan',
      applicationStep: 'Bekräftad av företag',
      motive: 'Företaget har bekräftat och skickat anmälan till lärlingen.',
      next: 'Lärlingen behöver bekräfta anmälan.',
      dependsOn: 'Lärlingen',
      actor: 'Företaget'
    },
    confirmedByStudent: {
      process: 'Företaget påbörjar anmälan',
      applicationStep: 'Bekräftad av lärling',
      motive: 'Lärlingen har bekräftat anmälan som företaget skapat.',
      next: 'Företaget behöver bekräfta och skicka in anmälan.',
      dependsOn: 'Företaget',
      actor: 'Lärlingen'
    },
    confirmedAndApprovedByCompany: {
      process: 'Företaget påbörjar anmälan',
      applicationStep: 'Bekräftad och godkänd av företag',
      motive: 'Företaget har bekräftat eventuella ändringar lärlingen gjort, godkänt anmälan och skickat in den till BYN.',
      next: 'BYN-regionär behöver godkänna anmälan.',
      dependsOn: 'Regionär med behörighet till BYN {{region}}',
      actor: 'Företaget'
    },
    ordered: {
      process: 'Gemensamma steg lärlingsanmälan: Företagslärling',
      applicationStep: 'Bekräftad anmälan',
      motive: 'En BYN-regionär har granskat och bekräftar anmälan och lärlingens kompletteringsbehov.',
      next: 'En annan BYN-regionär behöver godkänna beställningsunderlaget',
      dependsOn: 'Annan regionär än {{orderedBy}} med behörighet till BYN {{region}}',
      actor: '{{orderedBy}} (BYN {{region}})'
    },
    approved: {
      process: 'Gemensamma steg lärlingsanmälan: Företagslärling',
      applicationStep: 'Godkänd anmälan',
      motive: 'En annan BYN-regionär har godkänt anmälan och beställningsunderlaget är skickat till företaget.',
      next: 'Företaget behöver acceptera betalningsansvar för beställningsunderlaget.',
      dependsOn: 'Företaget',
      actor: '{{approvedBy}} (BYN {{region}})'
    },
    closed: {
      process: 'Gemensamma steg lärlingsanmälan: Företagslärling',
      applicationStep: 'Klar',
      motive: 'Företaget godkänner beställningsunderlaget och accepterar betalningsansvar. Härmed är lärlingsanmälan klar.',
      next: 'En beställning för distansutbildning skapas i Registret, företaget faktureras och beställningen skickas till distansutbildningsleverantören.',
      dependsOn: 'BYN kansli',
      actor: 'Företaget'
    },
    basicEducationCertificateIssued: {
      process: 'Gemensamma steg lärlingsanmälan: Kvalificeringstid',
      applicationStep: 'Granskad och godkänd grundutbildning',
      motive: 'En BYN-regionär har granskat och bedömt grundutbildningen som godkänd baserat på anmälan.',
      next: 'En annan BYN-regionär behöver bekräfta godkännandet av grundutbildningen.',
      dependsOn: 'Annan regionär än {{orderedBy}} med behörighet till BYN {{region}}',
      actor: '{{orderedBy}} (BYN {{region}})'
    },
    basicEducationCertificateApproved: {
      process: 'Gemensamma steg lärlingsanmälan: Kvalificeringstid',
      applicationStep: 'Klar',
      motive: 'En annan BYN-regionär har bekräftat godkännandet av grundutbildningen. Härmed är lärlingsanmälan klar.',
      next: 'Kvalificeringstiden har startat för lärlingen.',
      dependsOn: 'Lärlingen',
      actor: '{{approvedBy}} (BYN {{region}})'
    },
    closedDistanceEducation: {
      process: 'Gemensamma steg lärlingsanmälan: Kvalificeringstid',
      applicationStep: 'Klar',
      motive: 'En annan BYN-regionär har bekräftat godkännandet av grundutbildningen. Härmed är lärlingsanmälan klar.',
      next: 'Kvalificeringstiden har startat för lärlingen.',
      dependsOn: 'Lärlingen',
      actor: '{{approvedBy}} (BYN {{region}})'
    },
    transferDistanceEducationIssued: {
      process: 'Gemensamma steg lärlingsanmälan: Företagslärling',
      applicationStep: 'Bekräftad anmälan',
      motive: 'En BYN-regionär har granskat och bekräftat förflyttning.',
      next: 'En annan BYN-regionär behöver godkänna förflyttningen.',
      dependsOn: 'Annan regionär än {{orderedBy}} med behörighet till BYN {{region}}',
      actor: '{{orderedBy}} (BYN {{region}})'
    },
    transferDistanceEducationApproved: {
      process: 'Flytt av lärling till nytt företag',
      applicationStep: 'Klar',
      motive: 'Förflyttning till nytt företag har genomförts.',
      next: 'Lärlingen fortsätter med grundutbildningen på det nya företaget.',
      dependsOn: 'Lärlingen',
      actor: '{{approvedBy}} (BYN {{region}})'
    },
    transferBasicEducationCertificateIssued: {
      process: 'Gemensamma steg lärlingsanmälan: Kvalificeringstid',
      applicationStep: 'Bekräftad anmälan',
      motive: 'En BYN-regionär har granskat och bekräftat förflyttning.',
      next: 'En annan BYN-regionär behöver godkänna förflyttningen.',
      dependsOn: 'Annan regionär än {{orderedBy}} med behörighet till BYN {{region}}',
      actor: '{{orderedBy}} (BYN {{region}})'
    },
    transferBasicEducationCertificateApproved: {
      process: 'Gemensamma steg lärlingsanmälan: Kvalificeringstid',
      applicationStep: 'Klar',
      motive: 'Förflyttning till nytt företag har genomförts.',
      next: 'Lärlingen fortsätter med kvalificeringstiden på det nya företaget.',
      dependsOn: 'Lärlingen',
      actor: '{{approvedBy}} (BYN {{region}})'
    },
  }
  // Texts for company application statuses End here
}

export const ORDER_TEXTS = {
  // Texts for order statuses starts here
  sentToCompanyForApproval: {
    process: 'Beställning',
    status: 'Skickad till företag för godkännande',
    motive: 'Beställningen har skapats och skickats till företaget för godkännande. Företaget behöver godkänna fakturan inom utsatt tid för att lärlingens e-bok inte ska inaktiveras.',
    next: 'Företaget behöver granska och godkänna eller neka beställningen.',
    dependsOn: 'Företaget',
    actor: 'BYN {regionär2}'
  },
  approvedByCompany: {
    process: 'Beställning',
    status: 'Godkänd att fakturera',
    motive: 'Företaget har godkänt beställningen.',
    next: 'Beställningen skickas till eventuella leverantörer och BYN ställer ut en faktura såvida förskottsfakturering inte tillämpas.',
    dependsOn: 'Kanslist',
    actor: 'Företaget'
  },
  awaitingPayment: {
    process: 'Beställning',
    status: 'Fakturerad',
    motive: 'BYN har ställt ut en faktura till företaget.',
    next: '',
    dependsOn: 'Företaget',
    actor: 'Kanslist'
  },
  paid: {
    process: 'Beställning',
    status: 'Betald',
    motive: 'Företaget har betalt fakturan.',
    next: 'Systemet beställer distanskurser från eventuella leverantörer.',
    dependsOn: 'Kanslist',
    actor: 'Företaget'
  },
  commissioned: {
    process: 'Beställning',
    status: 'Beställd',
    motive: 'Beställningar har skickats till underleverantörer',
    next: 'Beställningen är avslutad.',
    dependsOn: ' ',
    actor: 'Kanslist'
  },
  standby: {
    process: 'Beställning',
    status: 'Avvakta',
    motive: ' ',
    next: ' ',
    dependsOn: ' ',
    actor: ' '
  },
}
